import React from "react";
import { Datagrid, TextField, List, ShowButton } from "react-admin";
import "./OrgPopup.css";

const OrgPendantPopup = (props) => {
  const orgId = parseInt(props.id) || parseInt(props.record.id) || null;
  return (
    <div>
      <div class="bg-overlay" onClick={props.onclickoutside} />
      <div class="org-popup">
        <h3>Owned Pendants</h3>

        <List
          title=""
          basePath={"/pendants"}
          resource="pendants"
          filter={{ org_id: orgId }}
          component={"div"}
        >
          <Datagrid>
            <TextField source="name" />
            <TextField source="uid" />
            <TextField source="type" />
            <ShowButton />
          </Datagrid>
        </List>
      </div>
      <div></div>
    </div>
  );
};

export default OrgPendantPopup;
